import React from 'react';
import PropTypes from 'prop-types';
import { add, format } from 'date-fns';
import styles from './ReviewOrder.module.scss';

import QuantityAdjuster from '../QuantityAdjuster/QuantityAdjuster';

import Disclaimer from '../Disclaimer/Disclaimer';

const ReviewOrder = (
  {
    incrementPressReleases,
    decrementPressReleases,
    numPressReleases,
    activePackageObject,
    activePackage,
    termsAccepted,
    handleTermsAccept,
  },
) => {
  const {
    pressReleaseListPrice,
  } = window.bulkPurchaseCodeCheckoutFlow;

  // This date logic relies on the BPC expiration date to be one year from today
  const dateOneYearInFuture = add(new Date(), { years: 1 });
  const formattedDate = format(dateOneYearInFuture, 'MMMM d, uuu');
  const noDiscountPrice = (pressReleaseListPrice * numPressReleases).toLocaleString();
  const discountedPrice = (
    (activePackageObject.price_per_press_release * numPressReleases) / 100
  ).toLocaleString();

  return (
    <div className={styles.container}>
      <div className={styles['review-info']}>
        <div className={styles.header}>Review order:</div>
        <div className={`row ${styles.pricing}`}>
          <div className="columns small-7">
            <div className={styles['price-per-pr']}>
              Press release bulk order {
                activePackage === 0
                  ? `$${pressReleaseListPrice}`
                  : `$${activePackageObject.price_per_press_release / 100}`
              } each
            </div>
          </div>
          <div className="columns small-5">
            <div className={styles.amounts}>
              {
                activePackage > 0
                && <div className={styles['amounts__list-price']}>${noDiscountPrice}</div>
              }
              <div className={styles['amounts__discount-price']}>
                {
                  activePackage > 0
                    ? `$${discountedPrice}`
                    : `$${noDiscountPrice}`
                }
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="columns small-7">
            <div className={styles.detail}>
              {`Credits valid through ${formattedDate}`}
            </div>
            {
              (activePackage > 0) && (
                <div className={styles.detail}>
                  {activePackageObject.minimum_quantity}+ Postings bulk order discount applied
                </div>
              )
            }
          </div>
          <div className="columns small-5">
            <div className={styles['quantity-widget-wrapper']}>
              <QuantityAdjuster
                incrementPressReleases={incrementPressReleases}
                decrementPressReleases={decrementPressReleases}
                numPressReleases={numPressReleases}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={`row columns ${styles.total}`}>
        <div className={styles.total__label}>
          Total:
        </div>
        <div className={styles['total__price-wrapper']}>
          <div className={styles['total__price-wrapper__price']}>
            {
              activePackage === 0
                ? `$${noDiscountPrice}`
                : `$${discountedPrice}`
            }
          </div>
        </div>
      </div>
      <div className={`row columns ${styles['disclaimer-wrapper']}`}>
        <Disclaimer
          termsAccepted={termsAccepted}
          handleTermsAccept={handleTermsAccept}
        />
      </div>
    </div>
  );
};

ReviewOrder.propTypes = {
  incrementPressReleases: PropTypes.func.isRequired,
  decrementPressReleases: PropTypes.func.isRequired,
  numPressReleases: PropTypes.number.isRequired,
  activePackageObject: PropTypes.shape({
    pk: PropTypes.number,
    minimum_quantity: PropTypes.number,
    price_per_press_release: PropTypes.number,
    is_best_value: PropTypes.bool,
    is_most_popular: PropTypes.bool,
  }).isRequired,
  activePackage: PropTypes.number.isRequired,
  termsAccepted: PropTypes.shape({
    value: PropTypes.bool,
    touched: PropTypes.bool,
    valid: PropTypes.bool,
    errors: PropTypes.arrayOf(PropTypes.any),
  }).isRequired,
  handleTermsAccept: PropTypes.func.isRequired,
};

export default ReviewOrder;
